import { IMAGES } from "@/config/site";

const DIRECTORS = [
  {
    title: "Athletics & Wellness",
    image: IMAGES.directorAthletics,
    copy: "Decades of professional physical training, endurance science, and vitality leadership.",
    testid: "director-athletics-card",
  },
  {
    title: "Financial Consulting",
    image: IMAGES.directorFinance,
    copy: "Specialists in capital markets, private debt facilities, and autonomous balance sheets.",
    testid: "director-finance-card",
  },
  {
    title: "Biomedical Sciences",
    image: IMAGES.directorBiomed,
    copy: "Translating biochemical and preventive protocols into daily living regimens.",
    testid: "director-biomed-card",
  },
  {
    title: "Psychological Sciences",
    image: IMAGES.directorPsych,
    copy: "Mentorship in cognitive resilience, self-governance, and autonomous decision-making.",
    testid: "director-psych-card",
  },
];

const Directors = () => {
  return (
    <section
      id="directors"
      data-testid="directors-section"
      className="py-24 px-6 border-b border-stone-800 bg-stone-900/20"
    >
      <div className="max-w-7xl mx-auto space-y-12">
        <div className="max-w-xl space-y-2">
          <span className="mono-tag text-xs uppercase tracking-widest text-amber-500 block">
            Leadership &amp; Directorship
          </span>
          <h2 className="text-3xl font-bold tracking-tight text-stone-100 display-serif">
            Cross-Sector Expertise
          </h2>
          <p className="text-stone-400 text-sm">
            Direct leadership from practitioners with decades of active domain experience.
          </p>
        </div>
        <div
          data-testid="directors-managing-poster"
          className="rounded-xl overflow-hidden border border-amber-500/30 bg-stone-950 max-w-2xl mx-auto shadow-[0_0_50px_rgba(245,158,11,0.08)]"
        >
          <img
            src={IMAGES.directorsManaging.url}
            alt={IMAGES.directorsManaging.alt}
            className="w-full h-auto block"
            loading="lazy"
          />
        </div>
        <div className="space-y-4">
          <p className="mono-tag text-[10px] uppercase tracking-widest text-amber-500">
            Named Offices
          </p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {[
              {
                href: "/directors/aharon-shepard",
                img: "/assets/directors/aharon-shepard-plaid.webp",
                name: "Aharon “J.D.” Shepard",
                role: "Treasury Management & International Finance",
                testid: "director-aharon-card",
              },
              {
                href: "/directors/miykha-shepard",
                img: "/assets/directors/miykha-shepard-plaid.jpg",
                name: "Miykhá Shepard",
                role: "Exchange Operations",
                testid: "director-miykha-card",
              },
              {
                href: "/directors/jalen-shepard",
                img: IMAGES.jalenShepard.url,
                name: "Jalen Shepard",
                role: "Sports Science & Analytics",
                testid: "director-jalen-card",
              },
            ].map((d) => (
              <a
                key={d.href}
                href={d.href}
                data-testid={d.testid}
                className="rounded-xl border border-stone-800 bg-stone-950 overflow-hidden hover:border-amber-600/50 transition-colors group"
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={d.img}
                    alt={`${d.name} — BGNZN Managing Director of ${d.role}`}
                    className="w-full h-full object-cover object-[50%_18%] group-hover:scale-105 transition-transform duration-700"
                    loading="lazy"
                  />
                </div>
                <div className="p-4 space-y-1">
                  <h3 className="text-sm font-bold text-stone-100">{d.name}</h3>
                  <p className="text-xs text-stone-400">
                    Managing Director — {d.role}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {DIRECTORS.map((director) => (
            <div
              key={director.title}
              data-testid={director.testid}
              className="p-5 rounded-xl bg-stone-950 border border-stone-800/80 space-y-3"
            >
              <div className="aspect-square rounded-lg border border-stone-800 relative overflow-hidden group">
                <img
                  src={director.image.url}
                  alt={director.image.alt}
                  className="absolute inset-0 w-full h-full object-cover object-[50%_18%] group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
              </div>
              <h3 className="text-sm font-bold text-stone-200">{director.title}</h3>
              <p className="text-xs text-stone-400">{director.copy}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Directors;
